import styles from "./ToTop.module.scss"
import { BiUpArrow } from 'react-icons/bi'

const ToTop = () => <a href="#" className={styles.top}><BiUpArrow /></a>


export default ToTop